import React, { useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import FloatButton from './FloatButton';
import { getCollectionList, getCollection, showProgress } from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import service from '../../apis/service';
import HandleCollectionCheckin from '../collections/HandleCollectionCheckin';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useCollection from '../collections/hooks/useCollection';

export default function SidebarListCollections(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const { fetchDepartments } = useCollection();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = React.useState(false);
  const selectedId = useSelector((state) => state.GetCollectionList.selectedId);
  const collectionDetails = useSelector((state) => state.getCollection.collection);

  const dispatch = useDispatch();

  const myRefs = React.useMemo(
    () =>
      filterArray?.reduce((acc, val) => {
        acc[val.id] = React.createRef();
        return acc;
      }, {}),
    [filterArray],
  );

  useEffect(() => {
    if (collectionDetails?.id && myRefs[collectionDetails.id]?.current) {
      myRefs[collectionDetails.id].current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [collectionDetails, filterArray, myRefs]);

  const handleListItemClick = (event, index, data) => {
    dispatch(getCollectionList('update_selectedId', {}, index));
    dispatch(getCollection('add', data));
    fetchCollection(data.id);
  };

  const addNewCollection = () => {
    setIsAddNewPopupOpen(true);
  };

  const closeAddNewCollection = () => {
    setIsAddNewPopupOpen(false);
  };

  const fetchCollection = async (id) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.COLLECTION_DETAIL.replace('ID', id))
      .then((response) => {
        dispatch(getCollection('add', response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const fetchCollections = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.JOURNEY_COLLECTION_LIST)
      .then((response) => {
        dispatch(getCollectionList('fetch', response, response[0]?.id));
        handleListItemClick(0, response[0]?.id, response[0] ? response[0] : []);
        dispatch(showProgress(false));
        fetchCollection(response[0]?.id);
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const value = props.value === undefined ? 0 : props.value;

  useEffect(() => {
    fetchCollections();
    fetchDepartments();
  }, []);

  const getJourneyCount = (data) => {
    const val = data?.journeys.length;
    switch (val) {
      case 0:
        return 'No Journeys Yet';
      case 1:
        return `${data?.journeys.length} Journey`;
      default:
        return `${data?.journeys.length} Journeys`;
    }
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => {
          const index = data.id;
          return (
            <div key={data.id} className={selectedId === index ? classes.highlightItem : ''}>
              <ListItem
                key={data.id}
                ref={myRefs[data.id]}
                button
                selected={selectedId === index}
                className={classes.listStyling}
                onClick={(event) => handleListItemClick(event, index, data)}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
                          ${selectedId === index ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                      >
                        {data.title}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div
                        className={selectedId === index ? classes.listSubTextSelected : classes.listSubTextNonSelected}
                      >
                        <div className={classes.listSubTextJustify}>
                          <div className={classes.listItemId}>ID: {data?.id}</div>
                          <div>{getJourneyCount(data)}</div>
                        </div>
                      </div>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={7} onAddNewCollection={addNewCollection} />
      {isAddNewPopupOpen && (
        <HandleCollectionCheckin
          open
          handleListItemClick={handleListItemClick}
          close={closeAddNewCollection}
          mode="add"
          id={collectionDetails}
        />
      )}
      {<ShowProgress />}
    </div>
  );
}
